import React, { useContext } from 'react';

import { SimpleFormBlock } from '@ww-digital/web-palette-react/dist/components/Block/SimpleFormBlock/SimpleFormBlock';
import { ProductsUtility } from '../../Utility/ProductsUtility.ts';
import { useLocation } from 'react-router-dom';

import styles from './FTMFormBlock.module.scss';
import {
  ConfigContextType,
  ConfigContext,
} from '../../../context/config.context.ts';

export const FTMFormBlock = (): JSX.Element => {
  const location = useLocation();
  const { translations } = useContext<ConfigContextType>(ConfigContext);

  const handleSubmit = (text: string) => {
    const ftm = text?.trim();
    if (!ftm) {
      return;
    }

    // Save the FTM value to cookie
    ProductsUtility.setFTMCookie(text);

    // Update form data to show success
    setFormData((prevData) => ({
      ...prevData,
      formData: {
        ...prevData.formData,
        success: true,
        successMessage:
          translations.REFERRAL_CODE_SUCCESS?.replace(
            '{{code}}',
            `<strong>${text}</strong>`,
          ) || '',
      },
    }));
  };

  const [formData, setFormData] = React.useState({
    headline: {
      ariaLevel: 3,
      text: translations.REFERRAL_CODE_HEADLINE,
      typog: 'subhead3',
    },
    textInput: {
      arrowButton: true,
      buttonText: translations.SUBMIT_BUTTON,
      placeholder: translations.REFERRAL_CODE_PLACEHOLDER,
      regex: /\S+/,
      regexErrorMessage: translations.REFERRAL_CODE_ERROR,
      text: '',
      onSubmit: handleSubmit,
    },
    formData: {
      errorMessage: '',
      loading: false,
      success: false,
      successMessage: '',
    },
  });

  // Load cookie value on component mount
  const [cookieLoaded, setCookieLoaded] = React.useState(false);

  React.useEffect(() => {
    const cookieValue = ProductsUtility.getFTMCookie();
    if (cookieValue) {
      setFormData((prevData) => ({
        ...prevData,
        textInput: {
          ...prevData.textInput,
          text: cookieValue,
        },
      }));
    }
    setCookieLoaded(true);
  }, []);

  // Check current path and query arg, and return null if form is not enabled
  if (
    location.pathname !== translations.COACH_REFERRAL_PATH ||
    location.search.includes('ftm=')
  ) {
    return <></>;
  }

  return (
    <SimpleFormBlock
      key={cookieLoaded ? 'with-cookie' : 'without-cookie'}
      {...formData}
      wrapperClassName={styles.formContainer}
    />
  );
};
